import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";
import { Button, Icon, Input, Modal, tokens, Typography, useCurrentDialog, useToast } from "@vintecc/components";
import { faArrowRight } from "@vintecc/pro-solid-svg-icons";
import { FC } from "react";

import { faCopy, faWebhook } from "@vintecc/pro-light-svg-icons";
import { useCommonTranslation } from "@/services/culture/common.translations";
import { useAdminTranslation } from "@/services/culture/admin.translations";

interface CustomAppSecretModalProps {
  secret: string;
}

export const CustomAppSecretModal: FC<CustomAppSecretModalProps> = ({ secret }) => {
  const { t: translateA } = useAdminTranslation();
  const { t: translateC } = useCommonTranslation();
  const { openToast } = useToast();
  const { close } = useCurrentDialog();
  const { copyToClipboard } = useCopyToClipboard();

  return (
    <Modal className="p-8 w-80" testId="custom-app-secret-modal">
      <div className="flex flex-col justify-center items-center gap-4 mb-8">
        <Icon icon={faWebhook} size="xl" />
        <div className="flex flex-col gap-2 items-center">
          <Typography variant="h3">{translateA("customApps.secret.title")}</Typography>
          <Typography variant="p" color={tokens.theme.error.color}>
            {translateA("customApps.secret.onceWarning")}
          </Typography>
        </div>
        <Input className="w-full" type="password" value={secret} readOnly aria-label={translateA("customApps.secret.title")} />
      </div>
      <div className="flex flex-col gap-4">
        <Button
          startIcon={<Icon icon={faCopy} />}
          onClick={() => {
            copyToClipboard(secret);
            close();
          }}
        >
          {translateC("common.copyToClipboard")}
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            close();
            openToast({ message: translateA("customApps.secret.createdTokenToast"), intent: "success" });
          }}
          endIcon={<Icon icon={faArrowRight} />}
        >
          {translateC("common.continue")}
        </Button>
      </div>
    </Modal>
  );
};
